import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

/**
 * An on/off toggle with real switch semantics (Space/Enter, `aria-checked`), styled as the
 * console's Dark/Light theme switch: off = dark (moon), on = light (sun).
 */
@Component({
  selector: 'esn-switch',
  imports: [IconComponent],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent {
  readonly checked = model(false);

  /**
   * Accessible name — the switch has no visible label of its own.
   */
  readonly label = input.required<string>();

  /**
   * Show the moon/sun glyph on the knob (the Figma theme switch); off for a plain toggle.
   */
  readonly icons = input(true);

  readonly disabled = input(false);

  protected toggle(): void {
    if (!this.disabled()) this.checked.update((on) => !on);
  }
}
